<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
      <v-row v-if="!isOriginal">
        <v-col cols="12" sm="4" class="pb-0 pt-2">
          <v-combobox
            v-model="selected"
            label="* Select lookup type"
            :items="
              orderType === 'nbn'
                ? items
                : items.filter(x => x !== 'Location ID' && x !== 'Geocode')
            "
            @change="resetValidation($event)"
            :disabled="withData || isOriginal"
          ></v-combobox>
        </v-col>
        <!--        <v-col-->
        <!--          cols="12"-->
        <!--          :sm="isSqPage ? '' : '3'"-->
        <!--          :lg="isSqPage ? '2' : '5'"-->
        <!--          :class="$vuetify.breakpoint.smAndDown ? '' : 'text-right pt-6'"-->
        <!--        >-->
        <!--          <v-btn-->
        <!--            class="primary"-->
        <!--            @click="showAddressMissing()"-->
        <!--            :disabled="isOriginal"-->
        <!--          >Can't find address</v-btn-->
        <!--          >-->
        <!--        </v-col>-->
      </v-row>

      <div v-if="selected !== 'Location ID' && !isOriginal">
        <v-row v-if="selected === 'Physical Address'">
          <v-col v-if="featureFlags.sog5802">
              <ValidationProvider
                v-slot="{ errors }"
                name="Geoscape Address Search"
                rules="required"
              >
                <v-autocomplete
                  label="Search for physical street Address, not PO Box"
                  :items="predictedAddresses"
                  v-model="nbnOrder.address"
                  :search-input.sync="predictAddress"
                  item-text="address"
                  item-value="id"
                  @change="getAddressDetails"
                  persistent-hint
                  autocomplete="off"
                  :error-messages="errors"
                  no-filter
                  return-object
                >
                </v-autocomplete>
              </ValidationProvider>
          </v-col>

          <v-col cols="12" class="pt-0 mt-0 pb-0" v-else>
            <ValidationProvider
              v-slot="{ errors }"
              name="Search for Address"
              rules="required"
            >
              <v-autocomplete
                :items="addressResults"
                label="Search for physical street Address, not PO Box"
                :search-input.sync="search"
                v-model="nbnOrder.address"
                item-text="formatted_address"
                item-value="formatted_address"
                @change="completeAddress"
                persistent-hint
                autocomplete="off"
                :error-messages="errors"
                :disabled="disableSearch"
                :readonly="isOriginal"
                no-filter
                return-object
              >
              </v-autocomplete>
            </ValidationProvider>
          </v-col>
        </v-row>

        <v-row v-if="selected === 'Geocode'">
          <v-col cols="6" class="mt-0 pb-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="Latitude"
              rules="required|between:-180.999999,180.999999"
            >
              <v-text-field
                label="Latitude"
                v-model="latitude"
                outlined
                :error-messages="errors"
                autocomplete="off"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col cols="6" class="mt-0 pb-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="Longitude"
              rules="required|between:-180.999999,180.999999"
            >
              <v-text-field
                label="Longitude"
                v-model="longitude"
                outlined
                :error-messages="errors"
                autocomplete="off"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
        </v-row>

        <v-row v-if="selected === 'GNAF ID'">
          <v-col cols="12" class="mt-0 pb-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="GNAF ID"
              rules="required"
            >
              <v-text-field
                label="GNAF ID"
                v-model="gnafId"
                outlined
                :error-messages="errors"
                autocomplete="off"
                :disabled="disableSearch"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
        </v-row>

        <!-- TO DO: change path to /service-qualification (feature flag) -->
        <v-row
          v-if="
            (selected !== 'Location ID' &&
              $route.path === '/service-qualification-nbn') ||
              $route.path === '/' ||
              $route.path === '/nbn-orders'
          "
        >
          <v-col class="pt-0 pb-0">
            <v-btn
              :disabled="invalid || !dirty || withData || isOriginal"
              class="primary mr-5"
              @click="submit()"
              v-if="showSubmit"
              >Submit</v-btn
            >
            <v-btn
              :disabled="invalid || !dirty || withData || isOriginal"
              @click="clear()"
              >Clear</v-btn
            >
          </v-col>
        </v-row>
      </div>
    </ValidationObserver>
    <invalid-address
      :showDialog="showDialog"
      :invalidItems="invalidItems"
      :isInvalid="isInvalid"
      :isValidated="isValidated"
      :title="title"
      @close="close"
    ></invalid-address>
  </div>
</template>

<script>
export default {
  name: "QualificationFormNbn",
  data: () => ({
    items: [
      "Physical Address",
      "Location ID",
      "Geocode",
      "GNAF ID",
      "Enhanced SQ - Service Transfer",
      "Enhanced SQ - Service Transition"
    ],
    selected: "Physical Address",
    result: {
      suburb: "",
      state: "",
      postCode: "",
      streetAddress: ""
    },
    search: null,
    streetAddress: "",
    longitude: "",
    latitude: "",
    gnafId: "",
    withData: false,
    queryAddress: [],
    showDialog: false,
    invalidItems: [],
    isInvalid: false,
    title: "",
    isValidated: false,
    checkType: "nbn",
    enableSubmit: true,
    disableRadio: false,
    address5gSq: {},
    processCount: 0,
    predictAddress: null,
  }),
  methods: {
    submit() {
      let vm = this;
      let payload = {};
      let data = {};
      let methodType = "";

      switch (vm.selected) {
        // case "Location ID":
        //   methodType = "NBN_LOCATION_ID";
        //   data = { LocationId: vm.locationId };
        //   break;
        case "Physical Address":
          methodType = "PHYSICAL_ADDRESS";

          if (vm.orderType === "nbn") {
            data = {
              StateOrProvince: vm.fullAddress.state,
              Postcode: vm.fullAddress.postcode,
              Suburb: vm.fullAddress.suburb,
              StreetName: vm.fullAddress.street_name,
              StreetType: vm.fullAddress.street_type,
              StreetNrFirst: vm.fullAddress.street_number
            };
          } else {
            data = {
              streetAddress: vm.fullAddress.street_address,
              unitNumber: "",
              unitType: "",
              streetNumber: vm.fullAddress.street_number,
              streetName: vm.fullAddress.street_name,
              streetType: vm.fullAddress.street_type,
              streetSuffix: vm.fullAddress.street_suffix,
              suburb: vm.fullAddress.suburb,
              postCode: vm.fullAddress.postcode,
              state: vm.fullAddress.state,
              gNAFIdentifier: vm.fullAddress.gnaf_id
            };
          }
          break;
        case "Geocode":
          methodType = "GEOCODE";
          data = {
            Longtitude: vm.longitude,
            Latitude: vm.latitude
          };
          break;
        case "GNAF ID":
          methodType = "GNAF_ID";

          if (vm.orderType === "nbn") data = { Gnafld: vm.gnafId };
          else {
            data = {
              gNAFIdentifier: vm.gnafId
            };
          }
          break;
      }

      if (vm.orderType === "nbn") {
        payload = {
          addressCheckServiceType: "NBN",
          addressCheckMethodType: methodType,
          addressValue: data
        };

        vm.nbnAddressQuery(payload).then(data => {
          if (data.data.status === 400 && vm.processCount < 2) {
            vm.processCount = vm.processCount + 1;
            vm.redoValidateAddress();
          } else {
            if (data.data) {
              vm.setResult(data.data);
              let details = {
                queryAddress: vm.queryAddress,
                streetAddress: vm.streetAddress,
                populatedAddress: vm.result,
                result: data.data
              };

              vm.$emit("showResultSection", details);
            }
          }
        });
        // payload = {
        //   addressCheckMethodType: methodType,
        //   addressValue: data,
        // };

        // if (methodType !== "GEOCODE") {
        //   vm.serviceQualificationNbn(payload).then((data) => {
        //     vm.showSqResult = true;
        //     vm.setFormattedNbnSQResult(data.data);
        //     vm.setProductType(data.data.sq.siteRestriction.supportingTechnology.primaryAccessTechnology);
        //     vm.setNtdId(data.data);
        //     vm.result = data.data;
        //     vm.$emit("showResultSection", data.data);
        //   });
        // } else {
        //   vm.nbnAddressQuery(payload).then((data) => {
        //     if (data.data.status === 400 && vm.processCount < 2) {
        //       vm.processCount = vm.processCount + 1;
        //       vm.redoValidateAddress();
        //     } else {
        //       if (data.data) {
        //         vm.setResult(data.data);
        //         let details = {
        //           queryAddress: vm.queryAddress,
        //         };
        //         vm.$emit("showResultSection", details);
        //       }
        //     }
        //   });
        // }
      } else {
        vm.serviceQualificationNbn(data).then(() => {
          vm.$emit("showResultSection", {});
        });
      }
    },
    redoValidateAddress() {
      let vm = this;
      vm.getAddress();
    },
    setResult(result) {
      let vm = this;
      vm.queryAddress = vm.reformatResult(result);
    },
    reformatResult(result) {
      let newAddress = [];
      result.forEach(x => {
        let addressFormat = {
          addressSiteName: x.addressSiteName,
          streetNrFirst: x.roadNumber1,
          streetNrLast: x.roadNumber2 ? x.roadNumber2 : "",
          streetName: x.roadName,
          streetType: x.roadTypeCode,
          suburb: x.localityName,
          postcode: x.postcode,
          stateOrProvince: x.stateTerritoryCode,
          longitude: x.longitude,
          latitude: x.latitude,
          locationId: x.id,
          formattedAddress: x.formattedAddress,
          lotNumber: x.lotNumber ? x.lotNumber : ""
        };

        newAddress.push(addressFormat);
      });
      return newAddress;
    },
    setValue(address, name) {
      let value = "";
      address.forEach(x => {
        if (x.name === name) value = x.value;
      });

      return value;
    },
    clear() {
      let vm = this;
      vm.result = {
        suburb: "",
        state: "",
        postCode: "",
        streetAddress: ""
      };
      vm.streetAddress = "";
      vm.longitude = "";
      vm.latitude = "";
      vm.gnafId = "";
      vm.setLocationID("");
      vm.SET_ADDRESS_RESULTS([]);
      vm.$emit("changed");
      vm.reset5gSq();
      vm.setSqResult({});
      vm.resetFormattedSQResult();
      vm.resetHasSectorId();
      vm.setPredictedAddress([]);
    },
    resetValidation(event) {
      let vm = this;
      //TO DO: change path to /service-qualification (feature flag)
      if (vm.$route.path === "/service-qualification-nbn") {
        if (event === "Location ID" || event === "Geocode") {
          vm.checkType = "nbn";
          vm.disableRadio = true;
        } else {
          vm.disableRadio = false;
        }
      }

      vm.latitude = "";
      vm.longitude = "";
      vm.gnafId = "";
      vm.selected = event;
      vm.result = {
        suburb: "",
        state: "",
        postCode: "",
        streetAddress: ""
      };
      vm.setLocationID("");
      vm.resetFormattedSQResult();
      vm.setFibreCheckbox(false);
      vm.id = "";
      vm.queryAddress = [];
      vm.reset5gSq();
      vm.$emit("changed", event);
      vm.$refs.observer.reset();
    },
    completeAddress(address) {
      let vm = this;
      vm.processCount = 0;
      vm.reset5gSq();
      vm.resetHasSectorId();
      vm.setSearchResultId(address.search_result_id);
      // if(vm.streetAddress === "Can't find address"){
      //   vm.showAddressDialog("Address Not Found");
      // }else{
      vm.getAddress();
      // }
    },
    getAddress() {
      let vm = this;
      vm.getFullAddress().then(addressResults => {
        if (addressResults.gnafId === "") {
          if (addressResults.state === "") vm.invalidItems.push("state");
          else if (addressResults.postcode === "")
            vm.invalidItems.push("postcode");
          else if (addressResults.suburb === "")
            vm.invalidItems.push("postcode");
          else if (addressResults.street_name === "")
            vm.invalidItems.push("street name");
          else if (addressResults.street_type === "")
            vm.invalidItems.push("street type");
          else if (addressResults.street_number === "")
            vm.invalidItems.push("street number");
          vm.isValidated = true;
          vm.isInvalid = true;
          vm.showAddressDialog("Error Details");
        } else {
          vm.submit();
        }
      });
    },
    showAddressDialog(title) {
      let vm = this;
      vm.title = title;
      vm.showDialog = true;
    },
    populateAddress(address) {
      let vm = this;
      if (address !== undefined) {
        vm.result.suburb = address.suburb;
        vm.result.state = address.state;
        vm.result.postCode = address.postcode;
        vm.result.streetAddress = address.street_address;
      } else {
        vm.result.suburb = vm.sqResult.addressField.suburb;
        vm.result.state = vm.sqResult.addressField.stateOrProvince;
        vm.result.postCode = vm.sqResult.addressField.postcode;
        vm.result.streetAddress = vm.sqResult.addressField.formattedAddress.substring(
          0,
          address.indexOf(",")
        );
      }
    },
    close() {
      let vm = this;
      vm.showDialog = false;
      vm.invalidItems = [];
      vm.isValidated = false;
      vm.isInvalid = false;
      vm.title = "";
    },
    showAddressMissing() {
      let vm = this;
      vm.showAddressDialog("Address Not Found");
    },
    getAddressDetails(value){
        let vm = this;
        vm.getVerifiedAddressDetail(value).then(result => {
            if (result) {
                let address = {
                  StateOrProvince: result.stateTerritory,
                  Postcode: result.postcode,
                  Suburb: result.localityName,
                  StreetName: result.streetName,
                  StreetType: result.streetType,
                  StreetNrFirst: result.streetNumber1
                };
                let payload = {
                  addressCheckServiceType: "NBN",
                  addressCheckMethodType: "PHYSICAL_ADDRESS",
                  addressValue: address
                };
                vm.nbnAddressQuery(payload).then(data => {
                    if (data.data) {
                      vm.setResult(data.data);
                      let details = {
                        queryAddress: vm.queryAddress,
                        streetAddress: vm.streetAddress,
                        populatedAddress: vm.result,
                        result: data.data
                      };
                  
                      vm.$emit("showResultSection", details);
                    }
                });
            }
        });
    },
  },
  computed: {
    isGoogleChrome() {
      return (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
      );
    },
    isSqPage() {
      let vm = this;
      //TO DO: change path to /service-qualification (feature flag)
      return vm.$route.path === "/service-qualification-nbn";
    },
    showSubmit() {
      let vm = this;
      if (vm.selected === "Geocode" || vm.selected === "GNAF ID") {
        return true;
      } else {
        return false;
      }
    },
    disableSearch() {
      let vm = this;
      if (vm.$route.path === "/") {
        return false;
      } else {
        return vm.withData || vm.checkType === "";
      }
    }
  },
  watch: {
    search: function(val) {
      let vm = this;
      if (val !== null && !vm.isOriginal) {
        if (val.length > 4) vm.searchAddress(val);
      }
    },
    selected: function() {
      let vm = this;
      vm.streetAddress = "";
      if (
        vm.selected === "Location ID" ||
        vm.selected === "Enhanced SQ - Service Transfer" ||
        vm.selected === "Enhanced SQ - Service Transition"
      )
        vm.$emit("toggleInput", true);
      else vm.$emit("toggleInput", false);
    },
    checkType() {
      let vm = this;
      vm.setOrderType(vm.checkType);
      vm.clear();
    },
    predictAddress: function(val) {
        let vm = this;
        if (val !== null && !vm.isOriginal) {
          if (val.length > 4) vm.getPredictAddresses(val);
        }
    }
  },
  beforeMount() {
    let vm = this;
    vm.clear();
  }
};
</script>

<style lang="scss" scoped></style>
